import { render, staticRenderFns } from "./PbRow.vue?vue&type=template&id=1d95b8fc&"
import script from "./PbRow.vue?vue&type=script&lang=js&"
export * from "./PbRow.vue?vue&type=script&lang=js&"
import style0 from "./PbRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports